// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"269":"e58bfd8f","631":"bee7ace1"}[chunkId] + ".css";
};